import { useQuery } from '@tanstack/react-query'

import { getBusinessDescriptions } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchBusinessDescriptions = () => {
  const { axiosInstance } = useAxios()

  return useQuery({
    queryFn: () => getBusinessDescriptions(axiosInstance),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_BUSINESS_DESCRIPTIONS],
  })
}
